/* 
    ./client/index.js
*/

import React from 'react';
import ReactDOM from 'react-dom';
import App from './app.js';
import ReactDOMServer from 'react-dom/server';

import { jss } from 'react-jss';
import DobraLight from './static/fonts/dobra/Dobra-Light.woff';
import DobraBold from './static/fonts/dobra/Dobra-Bold.woff';
import DobraBlack from './static/fonts/dobra/Dobra-Black.woff';
import DobraMedium from './static/fonts/dobra/Dobra-Medium.woff';
import DobraBook from './static/fonts/dobra/Dobra-Book.woff';

jss.createStyleSheet({
    '@global html, body': {
        fontFamily: 'Dobra',
    },
}).attach();

jss.createStyleSheet({
    '@font-face': {
        fontFamily: 'Dobra',
        fontWeight: '300',
        fontStyle: 'normal',
        src: `url(${DobraLight}) format("woff")`,
    },
}).attach();

jss.createStyleSheet({
    '@font-face': {
        fontFamily: 'Dobra',
        fontWeight: 'bold',
        fontStyle: 'normal',
        src: `url(${DobraBold}) format("woff")`,
    },
}).attach();

jss.createStyleSheet({
    '@font-face': {
        fontFamily: 'Dobra',
        fontWeight: '900',
        fontStyle: 'normal',
        src: `url(${DobraBlack}) format("woff")`,
    },
}).attach();

jss.createStyleSheet({
    '@font-face': {
        fontFamily: 'Dobra',
        fontWeight: '500',
        fontStyle: 'normal',
        src: `url(${DobraMedium}) format("woff")`,
    },
}).attach();

jss.createStyleSheet({
    '@font-face': {
        fontFamily: 'Dobra',
        fontWeight: 'normal',
        fontStyle: 'normal',
        src: `url(${DobraBook}) format("woff")`,
    },
}).attach();

ReactDOM.render(<App />, document.getElementById('root'));

// const html = ReactDOMServer.renderToString(<App />);